import * as yup from 'yup';
import { useUserPermissions } from 'services/user/permissions';

export const useGroupFormSchema = () => {

  const { checkPermission } = useUserPermissions();
  const isAdmin = checkPermission('admin-users', 'create');
  const isSystemAdmin = checkPermission('system-admin', 'create');

  const schema = yup.object().shape({
    name: yup.string().trim().required('accessGroupsNameRequired'),
  });

  if (isAdmin && !isSystemAdmin) {
    schema.fields.name = yup
      .string().trim().required('accessGroupsNameRequired')
      .test('not-gh-only', 'accessGroupsNameRequired', (value) => !(value && value.toUpperCase() === 'GH-'));
  }

  return schema;
};
